export const DOWNLOAD_LOCATION = 'download';
export const ASSET_LOCATION = `${DOWNLOAD_LOCATION}/assets`;
export const DOCUMENT_LOCATION = `${DOWNLOAD_LOCATION}/documents`;
export const BACKUP_DOCUMENT_LOCATION = `${DOWNLOAD_LOCATION}/documents/backups`;
export const ZIP_LOCATION = `${DOWNLOAD_LOCATION}/zip`;